/* eslint-disable eqeqeq */
import { useState } from "react";
import { useForm } from "react-hook-form";
// import FormBox from "./Form";

import {
  salDetailsFormOptions,
  salGeneralFormOptions,
  submitALoanFormOptions,
} from "./SalConstant";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { LiHandleButton, LoadingButton } from "../../Utils/CustomComponent";
import { Button } from "react-bootstrap";
import FormBox from "../../components/FormBox/FormBox";

const SALForm = () => {
  const [activeTab, setActiveTab] = useState(0);
  const schema = tabButtons.at(activeTab)?.validation
    ? tabButtons.at(activeTab)?.validation
    : null;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    // ...schema
  });

  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = async (data, func) => {
    // func();
    if (activeTab === tabButtons.length - 1) {
      setSubmitLoading(true);
      const id = toast.loading("Loan Submission Pending");

      try {
        // const headers = {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // };
        // await axios.post(
        //   urls.submitaLoan.postSubmitaLoan(),
        //   {
        //     user_id: localStorage.getItem("apex_userid"),
        //     loan_submission_details: data,
        //   },
        //   headers
        // );
        toast.update(id, {
          render: "Loan Submitted Succesfuly",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        setSubmitLoading(false);
      } catch (error) {
        console.error(error);
        toast.update(id, {
          render: "Error",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
      }
    }
  };
  const handleNextClick = () => {
    if (activeTab !== tabButtons.length - 1) {
      const func = () => setActiveTab((data) => data + 1);
      handleSubmit(onSubmit)(func);
    }
  };
  const handleBtnClick = (value) => {
    const func = () => setActiveTab(value);
    func();
    // handleSubmit(onSubmit)(func);
  };
  const handleBackClick = () => {
    if (activeTab !== 0) {
      setActiveTab((data) => data - 1);
    }
  };
  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded loan-onboarding-form"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h6>
              <a href="/submit-a-loan" style={{ textDecoration: "none" }}>
                Submit a Loan
              </a>{" "}
              / Form
            </h6>
          </div>
        </article>
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="row"></div>
            <h4 className="mt-5">Submit a Loan Form</h4>
            <div className="loan-details">
              <div className="pt-5 mt-5">
                <ul className="nav nav-tabs ">
                  {tabButtons?.map((data, index) => (
                    <LiHandleButton
                      key={index}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      label={data.label}
                      value={index}
                      handleBtnClick={handleBtnClick}
                    />
                  ))}
                </ul>
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="loans-in-details mt-5">
                {updatedSALFormInputArr?.map((data, index) => {
                  return activeTab == index ? (
                    <RenderComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                  ) : null;
                })}
                <div className="col-sm-10">
                  {activeTab !== 0 && (
                    <Button onClick={handleBackClick} className="me-2">
                      Back
                    </Button>
                  )}
                  {activeTab !== 8 && (
                    <Button onClick={handleNextClick} className="me-2">
                      Next
                    </Button>
                  )}
                  {activeTab === tabButtons.length - 1 && (
                    <LoadingButton
                      loading={submitLoading}
                      type="submit"
                      title={"Submit"}
                    />
                  )}
                </div>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};
export default SALForm;
let tabButtons = [
  { label: <p>Primary Borrower</p> },
  { label: <p>Terms</p> },
  { label: <p>Loan Account</p> },
];
export const RenderComp = ({ options, ...props }) => {
  return (
    <div className="row">
      {options.map((data) =>
        data.subArr ? (
          <NestedTabs {...props} options={data.subArr} />
        ) : (
          <div className={data?.className ? data.className : "col-12"}>
            <h4 className="mt-5 mb-4">{data.section}</h4>
            <FormBox {...props} options={data.arr} />
          </div>
        )
      )}
    </div>
  );
};
const NestedTabs = ({ options, ...props }) => {
  const [activeSubTab, setActiveSubTab] = useState(0);

  const handleBtnClick = (value) => {
    const func = () => setActiveSubTab(value);
    func();
    // handleSubmit(onSubmit)(func);
  };
  return (
    <>
      <>
        <ul className="nav nav-tabs ">
          {options?.map((data, index) => (
            <LiHandleButton
              key={index}
              activeTab={activeSubTab}
              setActiveTab={setActiveSubTab}
              label={data.subArrtitle}
              value={index}
              handleBtnClick={handleBtnClick}
            />
          ))}
        </ul>
        <div className="row">
          {options[activeSubTab].subArrarr.map((nestedTab) =>
            nestedTab?.subArr ? (
              <NestedTabs {...props} options={nestedTab.subArr} />
            ) : (
              <div
                className={
                  nestedTab?.className ? nestedTab.className : "col-12"
                }
              >
                <h4 className="mt-5 mb-4">{nestedTab.section}</h4>
                <FormBox {...props} options={nestedTab.arr} />
              </div>
            )
          )}
        </div>
      </>
    </>
  );
};
export const updatedSALFormInputArr = [
  {
    field: "primaryBorrower",
    arr: [
      {
        section: "Borrower Info",
        arr: [
          {
            title: "Full Name",
            field: "FullName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Salutation",
            field: "Salutation",
            type: "text",
            className: "col-6",
          },
          {
            title: "First Name",
            field: "FirstName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Last Name",
            field: "LastName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Street",
            field: "Street",
            type: "text",
            className: "col-12",
          },
          { title: "City", field: "City", type: "text", className: "col-6" },
          { title: "State", field: "State", type: "text", className: "col-3" },
          {
            title: "ZipCode",
            field: "ZipCode",
            type: "text",
            className: "col-3",
          },
          {
            title: "Phone (Home)",
            field: "PhoneHome",
            type: "text",
            className: "col-6",
          },
          { title: "TIN", field: "TIN", type: "text", className: "col-6" },
          {
            title: "Email",
            field: "EmailAddress",
            type: "text",
            className: "col-6",
          },
        ],
      },
    ],
  },
  {
    field: "terms",
    arr: [
      {
        section: "Loan Terms",
        arr: [
          {
            title: "Original Balance",
            field: "OrigBal",
            type: "text",
            className: "col-6",
          },
          {
            title: "Note Rate",
            field: "NoteRate",
            type: "text",
            className: "col-6",
          },
          {
            title: "Sold Rate",
            field: "SoldRate",
            type: "text",
            className: "col-6",
          },
          {
            title: "Priority",
            field: "Priority",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan Officer",
            field: "LoanOfficer",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan Code",
            field: "LoanCode",
            type: "text",
            className: "col-6",
          },
          {
            title: "First Payment Date",
            field: "FirstPaymentDate",
            type: "date",
            className: "col-6",
          },
          {
            title: "Maturity Date",
            field: "MaturityDate",
            type: "date",
            className: "col-6",
          },
          { title: "P & I", field: "PmtPI", type: "text", className: "col-6" },
          {
            title: "Reserve",
            field: "PmtReserve",
            type: "text",
            className: "col-6",
          },
          {
            title: "Impound",
            field: "PmtImpound",
            type: "text",
            className: "col-6",
          },
        ],
      },
    ],
  },
  {
    field: "loanAccount",
    arr: [
      {
        section: "Loan Account",
        arr: [
          {
            title: "Loan Account",
            field: "LoanAccount",
            type: "text",
            className: "col-6",
          },
          {
            title: "Lender Account",
            field: "LenderAccount",
            type: "text",
            className: "col-6",
          },
          {
            title: "Transaction Date",
            field: "TransDate",
            type: "date",
            className: "col-6",
          },
          {
            title: "Amount",
            field: "Amount",
            type: "text",
            className: "col-6",
          },
          {
            title: "Reference",
            field: "Reference",
            type: "text",
            className: "col-6",
          },
          {
            title: "Broker Fee (%)",
            field: "BrokerFeePct",
            type: "text",
            className: "col-6",
          },
          {
            title: "Vendor Fee (%)",
            field: "VendorFeePct",
            type: "text",
            className: "col-6",
          },
        ],
      },
    ],
  },
];
